import React, { Suspense, lazy } from "react";
import { Switch, Route } from "react-router-dom";
import App from "./app";
import Guid from "devextreme/core/guid";

const ThoughtspotSdkAppEmbed = lazy(() => import("./common_components/thoughtspot-sdk-app-embed"));
const ExternalAuditPerformanceComponent = lazy(() => import("./common_components/external-audit-performance-component"));
const CategoryManagement = lazy(() => import("./pages/category-management"));
const CustomerDocumentMangement = lazy(() =>
  import("./pages/customer-document-management")
);
const RefTaskList = lazy(() => import("./pages/task-template"));
const MyTasks = lazy(() => import("./pages/my-tasks"));
const TaskHQ = lazy(() => import("./pages/task-hq"));
const ProcessTemplate = lazy(() =>
  import("./pages/external-audit-setup/process-template")
);
const ExternalAudit = lazy(() => import("./pages/external-audit"));
const RequestersAndSources = lazy(() =>
  import("./pages/external-audit-setup/requestor-and-sources")
);
const config = lazy(() =>
  import("./common_components/common_widgets/navigation_bar/mdae-menu-click-handlers")

);
const AuditList = lazy(() => import("./pages/external-audit/audit-list"));
const Outcomes = lazy(() => import("./pages/external-audit-setup/outcomes"));
const ExternalDashboard = lazy(() => import("./pages/external-dashboard"));
const ManageDeletedExternalAudit = lazy(() =>
  import("./pages/external-audit-setup/manage-deleted-external-audit")
);
const ManageDeletedExternalCases = lazy(() =>
  import("./pages/external-audit-setup/manage-deleted-external-cases")
);
const DenialsPredictor = lazy(() =>
  import("./pages/analyzer/denials-predictor")
);
const ContentTypes = lazy(() => import("./pages/external-audit-setup/content-types"));
const ConfigureEmUtilization = lazy(() =>
  import("./pages/analyzer/configure-em-utilization")
);
const RiskAreaOutcomes = lazy(() =>
  import("./pages/analyzer/risk-area-outcomes")
);

const ManageDeletedEntities = lazy(() =>
  import("./pages/internal-audit-setup/manage-deleted-entities"));

const ExternalUsers = lazy(() =>
  import("./pages/user-management/external-users"));

const DenialReasons = lazy(() =>
  import("./pages/external-audit-setup/denial-reasons")
)
const CustomCodeSets = lazy(() =>
  import("./pages/customer-setup/custom-code-sets")
);
const CaseListPage = lazy(() =>
  import("./pages/external-audit/case-list-page/component")
);
const CaseSearchPage = lazy(() =>
  import("./pages/case-search/component")
);
const CustomCARCMapping = lazy(() => import("./pages/custom-CARC-mapping"));
const PayerGroups = lazy(() =>
  import("./pages/customer-setup/payer-groups")
);
const TaskGroups = lazy(() =>
  import("./pages/user-management/task-groups"));
const EMDRInbox = lazy(() => import("./pages/emdr-inbox"));
const EMDREnrollment =lazy(()=> import ("./pages/external-audit-setup/emdr-enrollment"));
const ReportViewConfiguration = lazy(() => import("./pages/report-configuration"));
const TargetRationalePage = lazy(() => import("./pages/external-audit-setup/target-rationale"));
const EditReportTemplate = lazy(() => import("./pages/report-configuration/edit-report-template"));

const DataConfiguration = lazy(() =>
  import("./pages/customer-setup/data-configuration")
);
const ExternalAuditHistory = lazy(() => import("./pages/external-audit/external-audit-history"));
const PolicySearch = lazy(() => import("./pages/code-and-policy-search/policy-search"));
const RootRouter = () => (
  <App isEatTheme={true}>
    <Suspense>
      <Switch>
        <Route
          exact
          path={"/audit/mytasks"}
          render={() => (
            <MyTasks
              myTaskWidgetId={new Guid().toString()}
              myPastDueTaskDrawerId={new Guid().toString()}
              myThisWeekTaskDrawerId={new Guid().toString()}
              myUpcomingTaskDrawerId={new Guid().toString()}
              myCompletedTaskDrawerId={new Guid().toString()}
            ></MyTasks>
          )}
        />
        <Route
          exact
          path={"/externalaudit/mytasks"}
          render={() => (
            <MyTasks
              myTaskWidgetId={new Guid().toString()}
              myPastDueTaskDrawerId={new Guid().toString()}
              myThisWeekTaskDrawerId={new Guid().toString()}
              myUpcomingTaskDrawerId={new Guid().toString()}
              myCompletedTaskDrawerId={new Guid().toString()}
            ></MyTasks>
          )}
        />
        <Route
          exact
          path={"/admin/tasktemplates"}
          render={() => <RefTaskList></RefTaskList>}
        />
        <Route
          exact
          path={"/externalaudit/admin/tasktemplates"}
          render={() => <RefTaskList></RefTaskList>}
        />

        <Route
          exact
          path={"/admin/CategoryManagement"}
          render={() => <CategoryManagement />}
        />
        <Route
          exact
          path={"/externalaudit/admin/categorymanagement"}
          render={() => <CategoryManagement />}
        />
        <Route
          exact
          path={"/admin/DocumentManagement"}
          render={() => <CustomerDocumentMangement />}
        />
        <Route
          exact
          path={"/externalaudit/admin/documentmanagement"}
          render={() => <CustomerDocumentMangement />}
        />
        <Route exact path={"/audit/taskhq"} render={() => <TaskHQ />} />
        <Route exact path={"/externalaudit/taskhq"} render={() => <TaskHQ />} />

        <Route
          exact
          path={"/externalaudit/admin/processtemplate"}
          render={() => <ProcessTemplate />}
        />
        <Route
          exact
          path={"/externalaudit/admin/requesterandsource"}
          render={() => <RequestersAndSources />}
        />

        <Route
          exact
          path={"/externalaudit/manualaudit"}
          render={() => <ExternalAudit />}
        />

        <Route
          exact
          path={"/externalaudit/caselist"}
          render={() => <CaseListPage />}
        />

        <Route
          exact
          path={"/externalaudit/casesearch"}
          render={() => <CaseSearchPage />}
        />
        <Route exact path={"/externalaudit/admin/processtemplate"} />
        <Route exact path={"/audit/taskhq"} render={() => <TaskHQ />} />
        <Route exact path={"/externalaudit/taskhq"} render={() => <TaskHQ />} />
        <Route
          exact
          path={"/externalaudit/emdrInbox"}
          render={() => <EMDRInbox></EMDRInbox>}
        />
        <Route
          exact
          path={"/externalaudit/emdrEnrollment"}
          render={() => <EMDREnrollment></EMDREnrollment>}
        />
        <Route
          exact
          path={"/externalaudit/audit"}
          render={() => (
            <ExternalAudit
              auditMyTaskWidgetId={new Guid().toString()}
              auditMyPastDueTaskDrawerId={new Guid().toString()}
              auditMyThisWeekTaskDrawerId={new Guid().toString()}
              auditMyUpcomingTaskDrawerId={new Guid().toString()}
              auditMyCompletedTaskDrawerId={new Guid().toString()}
              caseMyTaskWidgetId={new Guid().toString()}
              caseMyPastDueTaskDrawerId={new Guid().toString()}
              caseMyThisWeekTaskDrawerId={new Guid().toString()}
              caseMyUpcomingTaskDrawerId={new Guid().toString()}
              caseMyCompletedTaskDrawerId={new Guid().toString()}
            />
          )}
        />
        <Route
          exact
          path={"/externalaudit/admin/caseoutcomes"}
          render={() => <Outcomes />}
        />
        <Route
          exact
          path={"/externalaudit/allaudits"}
          render={() => <AuditList />}
        />
        <Route
          exact
          path={"/externalaudit/allaudits?myaudit=true"}
          render={() => <AuditList />}
        />
        <Route
          exact
          path={"/externalaudit/dashboard"}
          render={() => <ExternalDashboard />}
        />
        <Route
          exact
          path={"/externalaudit/deletedexternalaudits"}
          render={() => <ManageDeletedExternalAudit />}
        />
        <Route
          exact
          path={"/externalaudit/deletedexternalcases"}
          render={() => <ManageDeletedExternalCases />}
        />
        <Route
          exact
          path={"/analyzer/denialspredictor"}
          render={() => <DenialsPredictor />}
        />
        <Route
          exact
          path={"/analyzer/riskareaoutcomes"}
          render={() => <RiskAreaOutcomes />}
        />
        <Route
          exact
          path={"/audit/deletedauditentities"}
          render={() => <ManageDeletedEntities />}
        />
        <Route
          exact
          path={"/externalaudit/admin/contenttypes"}
          render={() => <ContentTypes />}
        />
        <Route
          exact
          path={"/Analyzer/emutilizationconfig"}
          render={() => <ConfigureEmUtilization />}
        />
        <Route
          exact
          path={"/usermanagement/externalusers"}
          render={() => <ExternalUsers />}
        />
        <Route
          exact
          path={"/externalaudit/usermanagement/externalusers"}
          render={() => <ExternalUsers />}
        />
        <Route
          path={"/externalaudit/admin/targetrationale"}
          render={() => <TargetRationalePage />}
        />
        {/* MDAI Pages' Route - Start*/}

        {/* Routes common to all modules */}

        {/* Insights.ai */}
        <Route
          exact
          path={"/mdai/allinsights"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="home"
              module="Audit Insights"
            />
          )}
        />

        <Route
          exact
          path={"/mdai/allinsights/?isforea=true"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="home"
              module="External Audit Insights"
            />
          )}
        />

        <Route
          exact
          path={"/mdai/allinsights/?isforro=true"}
          render={() => (
            <ThoughtspotSdkAppEmbed landingPage="home" module="Denial Risks" />
          )}
        />

        <Route
          exact
          path={"/mdai/allinsights/?isforpu=true"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="home"
              module="Procedure Utilization"
            />
          )}
        />

        {/* Self search */}
        <Route
          exact
          path={"/mdai/selfsearch"}
          render={() => <ThoughtspotSdkAppEmbed landingPage="search" />}
        />

        {/* Spot IQ */}
        <Route
          exact
          path={"/mdai/spotiqresults"}
          render={() => <ThoughtspotSdkAppEmbed landingPage="spotiq" />}
        />

        {/* AI module routes */}

        <Route
          exact
          path={"/mdai/auditactivitysummaryinternal"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="AuditActivitySummaryInternal"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/auditactivitysummaryexternal"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="AuditActivitySummaryExternal"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/auditresultssummaryexecutive"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="AuditResultsSummaryExecutive"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/auditresultssummaryfocused"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="AuditResultsSummaryFocused"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/auditresultssummaryprovidergrouprisks"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="AuditResultsSummaryProviderGroupRisks"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/audittargetanalysesIP"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="AuditTargetAnalysesIP"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/audittargetanalysesOP"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="AuditTargetAnalysesOP"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/audittargetanalysesprofessional"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="AuditTargetAnalysesProfessional"
            />
          )}
        />

        {/* PU module routes */}

        <Route
          exact
          path={"/mdai/procedureutilization"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="procedureutilization"
            />
          )}
        />

        <Route
          exact
          path={"/mdai/procedureutilization/hospitalclaims"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="procedureutilization-hospitalclaims"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/auditroi"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="auditroi"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/payerauditroi"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="payerauditroi"
            />
          )}
        />

        {/* EA MDAI module routes */}

        <Route
          exact
          path={"/externalaudit/mdai/departmentsummary"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="departmentSummary"
            />
          )}
        />
        <Route
          exact
          path={"/externalaudit/mdai/requestersummary"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="requesterSummary"
            />
          )}
        />
        <Route
          exact
          path={"/externalaudit/mdai/externalauditresults"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="externalAuditResults"
            />
          )}
        />
        <Route
          exact
          path={"/externalaudit/mdai/externalaudittargets"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="externalAuditTargets"
            />
          )}
        />

        {/* RO MDAI module routes */}

        <Route
          exact
          path={"/mdai/executiveoverview"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="ExecutiveOverviewPinboard"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/chargepaymentanalyses"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="chargepaymentanalyses"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/executiveoverviewcmiscores"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="ExecutiveOverviewPinboard-CMI-Scores"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/denialtrendinganalysis"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="DenialTrendingAnalysis"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/targeteddenialanalysisprofessional"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="TargetedDenialAnalysis-Professional"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/targeteddenialanalysisinstitutional"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="TargetedDenialAnalysis-Hospital"
            />
          )}
        />
        <Route
          exact
          path={"/externalaudit/mdai/eawbenchmarks"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="eawbenchmarks"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/professionalproviderrisk"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="professionalproviderrisk"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/professionalcoderrisk"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="professionalcoderrisk"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/professionalpayerrisk/"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="professionalpayerrisk"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/professionaltopcodes/"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="professionaltopcodes"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/outpatientfacilityrisk/"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="outpatientfacilityrisk"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/outpatientcoderrisk/"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="outpatientcoderrisk"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/outpatientpayerrisk/"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="outpatientpayerrisk"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/outpatienttopcodes/"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="outpatienttopcodes"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/inpatientfacilityrisk/"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="inpatientfacilityrisk"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/inpatientcoderrisk/"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="inpatientcoderrisk"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/inpatientpayerrisk/"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="inpatientpayerrisk"
            />
          )}
        />
        <Route
          exact
          path={"/mdai/inpatienttopcodes/"}
          render={() => (
            <ThoughtspotSdkAppEmbed
              landingPage="liveboard"
              liveboardName="inpatienttopcodes"
            />
          )}
        />
        {/* MDAI Pages' Route - End*/}
        <Route
          exact
          path={"/externalaudit/admin/denialreasons"}
          render={() => <DenialReasons />}
        />
        <Route
          exact
          path={"/customersetup/customcodesets"}
          render={() => <CustomCodeSets />}
        />
        <Route
          exact
          path={"/customersetup/payergroups"}
          render={() => <PayerGroups />}
        />
        <Route
          exact
          path={"/admin/customCARCMapping"}
          render={() => <CustomCARCMapping />}
        />
        <Route
          exact
          path={"/usermanagement/taskgroups"}
          render={() => <TaskGroups />}
        />
        <Route
          exact
          path={"/externalaudit/usermanagement/taskgroups"}
          render={() => <TaskGroups />}
        />
        <Route
          exact
          path={"/admin/auditreportconfiguration"}
          render={() => <ReportViewConfiguration />}
        />
        <Route
          exact
          path={"/customersetup/dataconfiguration"}
          render={() => <DataConfiguration />}
        />
        <Route
          exact
          path={"/externalaudit/customersetup/dataconfiguration"}
          render={() => <DataConfiguration />}
        />
        <Route
          exact
          path={"/externalaudit/externalaudithistory"}
          render={() => <ExternalAuditHistory />}
        />
        <Route
          exact
          path={"/policysearch"}
          render={() => <PolicySearch />}
        />
        <Route
          exact
          path={"/analyzer/policysearch"}
          render={() => <PolicySearch />}
        />
        <Route
          exact
          path={"/externalaudit/policysearch"}
          render={() => <PolicySearch />}
        />
      </Switch>
    </Suspense>
  </App>
);

export default RootRouter;
